"use strict";

module.exports = require("./is-implemented")()
	? Math.sign
	: require("./shim");



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/math/sign/index.js
// module id = 734
// module chunks = 0